import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { crmApi } from '@/services/api';
import { cardClass, inputClass, labelClass } from './styles';

const errMsg = (e: unknown, fallback: string) =>
  (e as { response?: { data?: { error?: string } } })?.response?.data?.error || fallback;

/** Ajustes de captación (ALTA LEAD 1.1): dirección del catálogo, aviso al equipo y enlace del formulario abierto. */
export default function LeadCaptureSettingsModal({ onClose }: { onClose: () => void }) {
  const [catalogUrl, setCatalogUrl] = useState('');
  const [notifyEmail, setNotifyEmail] = useState('');
  const [formUrl, setFormUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    crmApi.getLeadCaptureSettings()
      .then((r) => {
        setCatalogUrl(r.data.settings.catalog_url || '');
        setNotifyEmail(r.data.settings.notify_email || '');
        setFormUrl(`${window.location.origin}/solicitud/${r.data.orgSlug}`);
      })
      .catch((e) => toast.error(errMsg(e, 'No se pudieron cargar los ajustes')))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await crmApi.saveLeadCaptureSettings({ catalog_url: catalogUrl.trim(), notify_email: notifyEmail.trim() });
      toast.success('Ajustes guardados');
      onClose();
    } catch (e) { toast.error(errMsg(e, 'No se pudo guardar')); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className={`${cardClass} w-full max-w-lg p-6`} role="dialog" aria-modal="true" aria-label="Captación de leads">
        <h2 className="text-lg font-semibold text-gray-900">Captación de leads</h2>
        {loading ? <p className="text-sm text-gray-400 mt-4">Cargando…</p> : (
          <div className="mt-4 space-y-4">
            <div>
              <label className={labelClass}>Formulario abierto</label>
              <div className="flex gap-2">
                <input readOnly aria-label="Dirección del formulario abierto" className={`${inputClass} font-mono text-xs`} value={formUrl} onFocus={(e) => e.target.select()} />
                <button onClick={() => { void navigator.clipboard.writeText(formUrl); toast.success('Copiado'); }}
                  className="px-3 py-2 border border-vida-300 text-vida-700 rounded-lg text-sm font-medium hover:bg-vida-50">Copiar</button>
              </div>
              <p className="text-xs text-gray-400 mt-1">Compártelo o enlázalo desde la web. Cada solicitud entra aquí como lead.</p>
            </div>
            <div>
              <label className={labelClass} htmlFor="lead-catalog-url">Dirección del catálogo</label>
              <input id="lead-catalog-url" className={inputClass} placeholder="https://" value={catalogUrl} onChange={(e) => setCatalogUrl(e.target.value)} />
              <p className="text-xs text-gray-400 mt-1">Se envía a quien pide información de productos. Si está vacío, no se envía nada y le llamáis vosotros.</p>
            </div>
            <div>
              <label className={labelClass} htmlFor="lead-notify-email">Email del equipo</label>
              <input id="lead-notify-email" className={inputClass} placeholder="comercial@…" value={notifyEmail} onChange={(e) => setNotifyEmail(e.target.value)} />
              <p className="text-xs text-gray-400 mt-1">Recibe un aviso de cada solicitud. El lead lo ve como contacto si el catálogo no le basta.</p>
            </div>
          </div>
        )}
        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onClose} disabled={busy} className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800">Cancelar</button>
          <button onClick={save} disabled={busy || loading} className="px-4 py-2 bg-vida-600 text-white rounded-lg text-sm font-medium hover:bg-vida-700 disabled:opacity-50">
            {busy ? 'Guardando…' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}
